export default {
  // 中文配置
  // 用户交互-自定义CustomReason-content
  permission_change_text: '您在组织中的当前角色：', // 权限变更
  join_the_organization_successfully_text: '您的申请已被批准。', // 人员变动：申请通过
  application_rejection_text:
    '您的申请已被拒绝，您可以在开发者门户中重新发起申请。', // 人员变动：申请拒绝
  permission_remove_text: '您已被所有者从工作室中移除', // 人员变动：被移出X工作室
  new_join_organization_successfully: '您已成功加入组织', // 人员变动：新用户被邀请加入
  exits_text: '您已成功退出工作室。', // 主动退出 => 退出人

  // 用户交互- 自定义标题CustomSubject
  title_owner_transfer_notification: 'Owner 身份转移通知', // 权限变更 - Owner权限变更
  title_permission_change_text: '权限变更通知', // 权限变更, Admin权限变更,用户组成员变动
  title_group_permission_change: '用户组权限变更通知', // 权限变更 - 用户组权限变动
  title_group_scope_change: '用户组生效范围变更通知', // 权限变更 - 用户组范围变动通知
  title_permission_studio_delete: '工作室删除通知',
  title_permission_game_delete: '游戏删除通知',
  title_permission_env_delete: '环境删除通知',

  title_application_join_text: '申请加入组织', // 人员变动：申请加入组织
  title_join_the_organization_successfully_text: '成功加入组织', // 人员变动：申请通过<主动申请的加入>
  title_application_rejection_text: '申请被拒绝', // 人员变动：申请被拒绝
  title_permission_remove_text: '组织变更', // 人员变动：被移出X工作室
  title_new_join_organization_successfully: '成功加入工作室', // 人员变动：新用户被邀请加入
  title_exit_org: '组织变更', // 主动退出工作室
  title_service_open_success: '服务开通成功', // 服务开通成功
  title_service_open_failed: '服务开通失败', // 服务开通失败
  title_company_certified_successfully: '企业认证通过',
  title_company_certified_failed: '企业认证不通过',
  title_balance_alert: '余额预警通知',
  title_service_apply_pass: '申请服务成功',
  title_service_apply_pending: '服务申请',
  title_service_apply_fail: '申请服务失败',
  title_balance: '余额预警',
  changes_c: '[变更]',
  fixed_c: '[已修复]',
  announcement_c: '[公告]',
  changes_type: '变更',
  fixed_type: '已修复',
  announcement_type: '公告',
  notice_type: '系统通知',
  notice_apply_success: '[通知] 服务开通成功',
  notice_apply_failed: '[通知] 服务开通失败',
  apply_success_message: '服务开通成功',
  apply_failed_message: '服务开通失败',
};
